<template>
  <!--创建EXT跟grid配对的按钮-->
  <el-dialog :title="ConfigParam.type ?  $t('lang.editFolder') : $t('lang.addFolder')" :visible.sync="ConfigParam.show" width="600px" :center="true" :close-on-click-modal="false" class="EditTemplateFolder" @close="cancel">
    <div class="content scrollbar">
      <div class="type">
        <div class="item">
          <span>
            <i class="redColor">* </i>{{ $t("lang.name") }}</span>
          <el-input v-model.trim="name" autocomplete="off" size="small" :maxlength="125" :placeholder="$t('lang.FolderName')"></el-input>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="cancel" @click="cancel">{{ $t("lang.cancel") }}</el-button>
      <el-button class="save" v-if="!ConfigParam.type" v-repeat-click="{ event: save }" :loading='addFolderLoading'>{{ $t("lang.add") }}</el-button>
      <el-button class="save" v-else v-repeat-click="{ event: save }" :loading='addFolderLoading'>{{ $t("lang.save") }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import toTips from '@/assets/js/toTipsObj'
import Outil from '@/assets/js/utils.js'
import { componentsAnalyze, scheduleAnalyze, playoutAnalyze } from '../../assets/js/googleAnalyze/playout.js'

export default {
  props: {
    ConfigParam: {
      type: Object,
      default: () => ({
        // 是否显示
        show: false,
        // 文件名
        name: '',
        // 父文件夹名字
        parentId: '',
        // 文件id
        id: '',
        type: 0 // 0创建 1编辑
      })
    }
  },
  data () {
    return {
      // 文件夹名字
      name: '',
      // 所在页面地址
      pageMark: '',
      // s3的bucket
      bucket: '',
      // loading效果
      addFolderLoading: false
    }
  },
  created () {
    this.bucket = this.$BehaviorSyns.getRegionBucket('bucket')
  },
  mounted () {
    if (this.ConfigParam.type) {
      this.name = this.ConfigParam.name
    }
    this.getCurrentPage()
  },
  methods: {
    // 获取当前页面
    getCurrentPage () {
      this.pageMark = window.location.hash.split('#')[1]
    },
    // 新增文件夹
    addFolder () {
      componentsAnalyze('addEditFolderAdd', '/ponent')
      const param = {
        folderName: this.name,
        parentId: this.ConfigParam.parentId,
        bucketCode: this.bucket
      }
      this.addFolderLoading = true
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/addFolder', param,
          {
            contentType: 'application/json;charset=UTF-8'
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
            this.addFolderLoading = false
            this.$emit('queryFolder', 'Folder')
            this.ConfigParam.show = false
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) ||
              res.data.errorInfo
            this.$message.info(errorInfo)
            this.addFolderLoading = false
          }
        }).catch(() => {})
    },
    // 编辑接口
    saveData () {
      componentsAnalyze('addEditFolderSave', '/ponent')
      const param = {
        folderName: this.name,
        bucketCode: this.bucket,
        id: this.ConfigParam.id,
        objectKey: this.ConfigParam.objectKey,
        programId: Outil.getProgramReceiver().ProgramId
      }
      this.addFolderLoading = true
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/editFolder',
          param,
          {
            contentType: 'application/json;charset=UTF-8'
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
            this.addFolderLoading = false
            this.$emit('queryFolder', 'Folder')
            this.ConfigParam.show = false
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) ||
              res.data.errorInfo
            this.$message.info(errorInfo)
            this.addFolderLoading = false
          }
        }).catch(() => {})
    },
    save () {
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeHeaderAddFolderSave', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeHeaderAddFolderSave', '/pop')
      }
      this.name = typeof this.name == 'string' ? this.name.trim() : this.name
      if (!this.name || (this.name && this.name.length < 3)) {
        this.$message.error(this.$t('lang.extSourceNameTips'))
        return
      }
      if (this.name.indexOf('/') >= 0) {
        this.$message.error('"/" is not allowed in the folder name')
        return
      }
      if (this.ConfigParam.type) {
        this.saveData()
      } else {
        this.addFolder()
      }
    },
    cancel () {
      componentsAnalyze('addEditFolderCanCel', '/ponent')
      this.ConfigParam.show = false
    }
  }
}
</script>
<style lang="less" scoped>
.EditTemplateFolder {
  .scrollbar {
    overflow-x: hidden;
  }

  .content {
    text-align: left;
    font-size: 16px;
    max-height: 55vh;
    overflow-y: auto;

    .item {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      span {
        display: block;
        margin-bottom: 5px;
      }
    }

    ::v-deep .el-input .el-input__inner {
      border: 1px solid #444;
      background: #444;
      color: white !important;

      &::-webkit-input-placeholder {
        color: #666;
      }
    }

    ::v-deep .select-box {
      width: 100%;

      .el-input__inner {
        border: 1px solid #444;
        background: #444;
      }
    }

    ::v-deep .el-select {
      width: 100%;

      .el-select__input {
        color: #fff;
      }
    }

    ::v-deep .selectRlist {
      width: 100%;
      height: 300px;
      overflow-y: auto;
    }
  }
}

.delete {
  width: 120px;
}
</style>
